import { dayMs, hourMs, minuteMs } from "verdi-common/timeConstants";
import type { TimeEvent } from "../../band-data/types";
import { clockParts, formatClockTime, formatDayTime, isSameLocalDay } from "../../format";

/** "6:00 – 9:00 am", "6:00 am – 2:00 pm", "Sep 19, 10:05 pm – Sep 20, 1:20 am"; "since 6:04 am" while running. */
export function formatSpan(event: TimeEvent, nowMs: number): string {
    const { startMs, endMs } = event;

    if (endMs === null) {
        return `since ${isSameLocalDay(startMs, nowMs) ? formatClockTime(startMs) : formatDayTime(startMs)}`;
    }
    if (!isSameLocalDay(startMs, endMs)) return `${formatDayTime(startMs)} – ${formatDayTime(endMs)}`;

    const [startTime, startPeriod] = clockParts(startMs);
    const [, endPeriod] = clockParts(endMs);
    const start = startPeriod === endPeriod ? startTime : formatClockTime(startMs);
    return `${start} – ${formatClockTime(endMs)}`;
}

/** "6m", "1h 5m", "2d 4h": the irrigation row's totals. */
export function formatDuration(ms: number): string {
    const minutes = Math.floor(ms / minuteMs) % 60;
    const hours = Math.floor(ms / hourMs) % 24;
    if (ms < hourMs) return `${minutes}m`;
    if (ms < dayMs) return `${hours}h ${minutes}m`;
    return `${Math.floor(ms / dayMs)}d ${hours}h`;
}
